import { useQueryClient } from '@tanstack/react-query';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { isLastOwnerQueryKey, lastOwnerCandidateUserId } from '../ContactsCard.utils';
const LAST_OWNER_CHECK_LOADER = 'last-owner-check-loader';
export const useIsLastOwnerCheck = (clientId)=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { startLoader, stopLoader } = useOverlayContext();
    const fetchIsLastOwner = (userId)=>queryClient.fetchQuery({
            queryKey: isLastOwnerQueryKey(userId, clientId),
            staleTime: 0,
            queryFn: ()=>api.user.isLastOwner(userId, clientId)
        });
    const isLastOwner = async (contact)=>{
        const candidateUserId = lastOwnerCandidateUserId(contact);
        if (candidateUserId == null) return false;
        startLoader(LAST_OWNER_CHECK_LOADER);
        try {
            return await fetchIsLastOwner(candidateUserId);
        } catch (unused) {
            return false;
        } finally{
            stopLoader(LAST_OWNER_CHECK_LOADER);
        }
    };
    return {
        isLastOwner
    };
};
